import { useInfiniteQuery } from "react-query";

import { getPaginationReviews } from "../remotes/getReviews";
import type { SangjoReviewTag } from "@/types/reviewType";

interface IUseReviewListByTag {
  page?: number;
  tag?: SangjoReviewTag;
}

export const useReviewListByTag = ({ page = 1, tag }: IUseReviewListByTag) => {
  const { data, fetchNextPage, hasNextPage, isFetchingNextPage } = useInfiniteQuery(
    ["sangjoReviews", tag],
    ({ pageParam = 1 }) => getPaginationReviews(pageParam, tag),
    {
      getNextPageParam: (lastPage) => {
        if (!lastPage.next) return undefined;
        return Number(new URL(lastPage.next).searchParams.get("page"));
      },
    },
  );

  return { data, fetchNextPage, hasNextPage, isFetchingNextPage };
};
